import Markup, { enhanceHtml } from './Markup.tsx'

export default function BlankPage({
  articleClass,
  articleId,
  html,
}: {
  articleClass: string
  articleId: string
  html: string
}) {
  return (
    <div id="x-main" className="x-main full" role="main" tabIndex={-1}>
      <article id={articleId} className={articleClass}>
        <div className="entry-content content">
          <div id="cs-content" className="cs-content" dangerouslySetInnerHTML={{ __html: enhanceHtml(html) }} />
        </div>
      </article>
    </div>
  )
}

export function SidebarPage({ html }: { html: string }) {
  return <Markup html={html} />
}
